import { HTTP_INTERCEPTORS } from '@angular/common/http';

import {AuthInterceptor} from './auth-interceptor';
import {CachingInterceptor} from './caching-interceptor';
import {EnsureHttpsInterceptor} from './ensure-https-interceptor';
import {LoggingInterceptor} from './logging-interceptor';
import {UploadInterceptor} from './upload-interceptor';
import {HttpErrorInterceptor} from './http-error-interceptor';
import {environment} from "../../../environments/environment";


/** Http interceptor providers in outside-in order */
export const httpInterceptorProviders = environment.production ? [
  {provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true},
  {provide: HTTP_INTERCEPTORS, useClass: EnsureHttpsInterceptor, multi: true},
  {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
  {provide: HTTP_INTERCEPTORS, useClass: LoggingInterceptor, multi: true},
  {provide: HTTP_INTERCEPTORS, useClass: UploadInterceptor, multi: true},
  {provide: HTTP_INTERCEPTORS, useClass: CachingInterceptor, multi: true},
] : [
  {provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true},
  {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
  {provide: HTTP_INTERCEPTORS, useClass: LoggingInterceptor, multi: true},
  {provide: HTTP_INTERCEPTORS, useClass: UploadInterceptor, multi: true},
  {provide: HTTP_INTERCEPTORS, useClass: CachingInterceptor, multi: true},
];
